import { render } from "./TvAirplaneWrap.vue?vue&type=template&id=aa810996&scoped=true&ts=true"
import script from "./TvAirplaneWrap.vue?vue&type=script&lang=ts"
export * from "./TvAirplaneWrap.vue?vue&type=script&lang=ts"

import "./TvAirplaneWrap.vue?vue&type=style&index=0&id=aa810996&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa810996"]])

export default __exports__